import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { alpha, Box, Button, Typography } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import UseTranslation from '../../hooks/UseTranslation'

const LoadMoreBtn = ({ actionToDispatch, store, actionQueries = {},
  customStyles, sendQueryAsObject }) => {
  const { t } = UseTranslation()
  const dispatch = useDispatch()
  const pageNumber = store.pageNumber + 1
  const moreBtn = useRef(null)

  useEffect(() => {
    window.onscroll = () => {
      if (
        document.body.offsetHeight - window.innerHeight < window.scrollY &&
        store.pageNumber < 3
      ) {
        moreBtn?.current?.click()
      }
    }
  }, [store])

  const retrieveData = () => {
    if (sendQueryAsObject) {
      dispatch(actionToDispatch({ queries: { pageNumber: store.pageNumber + 1 } }))
    } else {
      dispatch(
        actionToDispatch({
          queries: {
            pageNumber,
            activeSummary: store.activeSummary,
            activeSearch: store.activeSearch,
          },
          actionQueries,
        }),
      )
    }
  }

  const isLoading = Boolean(store.loading === true); // Ensures it's always a boolean
  const isFetching = store.loading && typeof store.loading === 'object' ? store.loading.fetch : false;
  const isMutating = store.loading && typeof store.loading === 'object' ? store.loading.mutate : false;

  return !store.finalPage ? (
    <Button
      sx={[styles.loadMoreButton, customStyles]}
      disabled={(isLoading || isFetching || isMutating)}
      onClick={retrieveData}
      ref={moreBtn}>
      {t?.['Load More']}
      <KeyboardArrowDownIcon />
    </Button>
  ) : (
    !isLoading && !isFetching && !isMutating && store.data?.length > 0 && (
      <Box sx={styles.noMoreResultContainer}>
        <Typography variant="heading6" sx={styles.noMoreResult}>
          {t?.['No More Results']}
        </Typography>
      </Box>
    )
  )
}

const styles = {
  loadMoreButton: {
    backgroundColor: 'white',
    width: '100%',
    borderRadius: '10px',
    boxShadow: '0 0 2px 0 rgba(188, 188, 212, 0.4)',
    padding: '20px',
    marginBottom: '10px',
    position: 'relative',
    display: 'flex',
    fontWeight: 'typography.fontWeightBold',
    color: 'primary.main',
    textTransform: 'none',
    '&:hover, &:focus': {
      color: alpha('#29cc8b', 0.75),
    },
  },
  noMoreResultContainer: {
    display: 'flex',
    justifyContent: 'center',
    mt: '5px',
  },
  noMoreResult: {
    display: 'block',
    textAlign: 'center',
    color: 'grey',
    marginBlock: '10px',
  },
}

export default LoadMoreBtn
